import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faEye,
    faEyeSlash,
    faExclamationTriangle,
    } from '@fortawesome/free-solid-svg-icons';

library.add(
    faEye,
    faEyeSlash,
    faExclamationTriangle,
);